import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import {Typography} from '@mui/material';
import HighchartsAccessibility from 'highcharts/modules/accessibility';
import {t} from 'i18next';
import {numberFormatter} from '../../../utils/utils';

interface IchartData {
  name: string;
  y: number;
  type: string;
}

HighchartsAccessibility(Highcharts);

interface ICustomPieChart {
  backgroundColor?: string;
  title?: string;
  fieldName?: string;
  data: IchartData[];
  colors: string[];
}

const AurDocPiechart = (props: ICustomPieChart) => {
  const {backgroundColor, title, fieldName, data, colors} = props;

  // Calculate total docs
  const totalDocs = data.reduce((sum, item) => sum + item.y, 0);

  function getSubtitle() {
    return `<div style=<span class="typo-text display3_size mist-color-100" style="font-size: 40px">${numberFormatter(totalDocs)}</span>
            <br>
            <span class="typo-text body3_size mist-color-700" style="font-size: 22px">
                ${t('common.totalFiles')}</b> 
            </span>`;
  }

  const options = {
    chart: {
      type: 'pie',
      backgroundColor: backgroundColor,
    },
    accessibility: {
      enabled: true,
      description: title,
      point: {
        valueDescriptionFormat:
          '{index + 1}. {point.name}, {point.y} units, {point.percentage:.1f}% of total.',
      },
      keyboardNavigation: {
        enabled: true,
      },
    },
    plotOptions: {
      pie: {
        innerSize: '65%',
        borderWidth: 3,
        borderColor: backgroundColor,
        size: '90%',
      },
    },
    title: false,

    subtitle: {
      useHTML: true,
      text: getSubtitle(),
      floating: true,
      verticalAlign: 'middle',
      y: 10,
    },
    credits: {
      enabled: false,
    },
    tooltip: {
      formatter: function (): string {
        const point = (this as any).point as Highcharts.Point & {
          customType?: string;
        };
        const type = point.customType;

        return `<b>${t('eca.flyout.docCount')}</b> ${numberFormatter(point.y ?? 0)} ${t('common.docs')}<br><b>${t('eca.searchTermReport.reviewSearch.type')}</b> ${type}`;
      },
    },
    series: [
      {
        name: fieldName,
        data: data.map((item, index) => ({
          ...item,
          customType: item.type,
          color: colors[index],
        })),
        colorByPoint: true,
      },
    ],
  };

  return (
    <>
      <Typography className="typo-text subhead3_size mist-color-100">
        {title}
      </Typography>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </>
  );
};

export default AurDocPiechart;
